<template>
  <div class="notification-detail-page">
    <b-card class="mb-3" header="Notification Details">
      <h4 class="card-title blue-title">Title: {{ notification.title }}</h4>
      <p class="card-text"><strong>Message:</strong> {{ notification.message }}</p>

      <p class="card-text">
        <strong>Vehicle Identification Number:</strong>
        <router-link
          v-if="notification.vehicle?.vin"
          :to="{ name: 'ListVehicle', params: { vin: notification.vehicle.vin } }"
          v-b-tooltip.hover
          title="Redirect to the Vehicle page for searching the vehicle through this VIN"
        >
          {{ notification.vehicle.vin }}
        </router-link>
        <span v-else class="text-muted">N/A</span>
      </p>

      <p class="card-text">
        <strong>Registration Number:</strong>
        {{ notification.vehicle?.registration_number || "N/A" }}
      </p>
      <p class="card-text">
        <strong>Date and Time:</strong> {{ formattedDate }}
      </p>
      <!-- Image  code here  -->
      <div v-if="lightboxVisible" class="lightbox" @click="closeLightbox">
        <div class="lightbox-content">
          <img :src="selectedImage" alt="Vehicle Image" class="lightbox-image" />
        </div>
      </div>

      <div style="margin-left: 3px; margin-bottom: 15px">
        <img v-if="image" :src="'https://wossdb.wossautoid.com/' + image" alt="Stolen  Place" width="100" height="100"
          @click="openLightbox(image)" />
        <div v-else>
          <span>
            No image available
          </span>
        </div>
      </div>

      <!-- Trigger the modal with the Delete button -->
      <b-button  v-b-tooltip.hover title="Delete Notification" variant="primary" @click="showDeleteModal" class="mt-3">Delete</b-button>
    </b-card>

    <!-- Delete Confirmation Modal -->
    <b-modal id="delete-confirmation-modal" ref="deleteModal" title="Confirm Delete" @ok="deleteNotification"
      ok-title="Confirm" ok-variant="danger" cancel-title="Cancel" hide-footer>
      <p>Are you sure you want to delete this notification?</p>
      <b-button variant="primary" @click="confirmDelete" class="mr-2">Confirm</b-button>
      <b-button variant="primary" @click="cancelDelete">Cancel</b-button>
    </b-modal>
  </div>
</template>


<script>
import axios from "../../../axios";
import { BCard, BButton, BModal } from "bootstrap-vue";
import { notificationBus } from "../../../utils/notificationRealtime";

export default {
  components: {
    BCard,
    BButton,
    BModal,
  },
  data() {
    return {
      notification: {},
      // notification: null,
      formattedDate: '',
      image: "",
      lightboxVisible: false,
      selectedImage: '',
    };
  },

  methods: {
    openLightbox(imgPath) {
      this.selectedImage = `https://wossdb.wossautoid.com/${imgPath}`;
      this.lightboxVisible = true;
    },
    closeLightbox() {
      this.lightboxVisible = false;
    },

    async fetchNotificationDetail() {
      const id = this.$route.params.id;
      try {
        const response = await axios.get(`showNotification/${id}?_=${Date.now()}`);
        this.notification = response.data.notification;
        this.image = this.notification?.image || "";

        this.formattedDate = this.formatDate(this.notification.created_at);

        notificationBus.$emit("sync", {
          payload: {
            action: "viewed",
            id: Number(id),
            notification_id: Number(id),
          },
          userType: "super_admin",
        });
      } catch (error) {
        console.error(error);
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString();
    },


    showDeleteModal() {
      this.$refs.deleteModal.show();
    },

    // Method to delete the notification
    async deleteNotification() {
      const id = this.$route.params.id;
      try {
        await axios.delete(`deleteNotificationAdmin/${id}`);
        this.$refs.deleteModal.hide();
        // this.$router.push("/dashboards");
        this.$router.push({ path: '/dashboards' }).then(() => {
          location.reload(); // Force page refresh
        });
      } catch (error) {

      }
    },
    confirmDelete() {
      this.deleteNotification();
    },

    cancelDelete() {
      this.$refs.deleteModal.hide();
    },
  },
  mounted() {
    this.fetchNotificationDetail();
  },
  watch: {
    '$route.params.id'(newId) {
      this.fetchNotificationDetail();
    }
  },
};
</script>


<style scoped>
.blue-title {
  color: blue;
}

.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.lightbox-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
}

.lightbox-image {
  max-width: 100%;
  max-height: 80vh;
}
</style>
